import { classNames } from "@ember-decorators/component";
import periodTitle from "discourse/helpers/period-title";
import discourseComputed from "discourse/lib/decorators";
import { i18n } from "discourse-i18n";
import DropdownSelectBoxRowComponent from "select-kit/components/dropdown-select-box/dropdown-select-box-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const PeriodChooserRow = dt7948.c(class PeriodChooserRow extends DropdownSelectBoxRowComponent {
  title(rowName) {
    return i18n(`filters.top.${rowName || "this_week"}`).title;
  }
  static {
    dt7948.n(this.prototype, "title", [discourseComputed("rowName")]);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <span class=\"selection-indicator\"></span>\n\n    <span class=\"period-title\">\n      {{periodTitle this.rowValue showDateRange=true fullDay=this.selectKit.options.fullDay}}\n    </span>\n  ", {
      strictMode: true,
      scope: () => ({
        periodTitle
      })
    }), this);
  }
}, [classNames("period-chooser-row")]);
export default PeriodChooserRow;